import axios from "axios";
import { BASE_URL } from "../../variables";

export const getDealerRelationshipMeetApi = async (globalAccessToken, salesgroupCode) => {
  try {
    // Encode salesgroupCode for safety
    const query = `SELECT Dealer_Selection_Criteria__c, If_Category_Specific_dealers_then_which__c, Objective_of_meet__c, Sales_Group_Code__c, Town_Selection_criteria__c, Type_of_DRM__c, Planned_DRM_Type__c FROM Dealerrelationship_meet_picklist__c WHERE Sales_Group_Code__c = '${salesgroupCode}'`;

    const url = `${BASE_URL}/services/data/v56.0/query/?q=${query}`;

    const options = {
      url,
      method: "get",
    };

    const response = await axios(options);

    if (response.status === 200) {
      const record = response.data.records[0];

      const serializedResult = {};
      for (const key in record) {
        if (key.endsWith("__c") && typeof record[key] === "string") {
          serializedResult[key] = record[key]
            .split(";")
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
        }
      }

      console.log('serializedResult', serializedResult);
      

      return {
        success: true,
        data: serializedResult, // Directly return records array
      };
    } else {
      throw new Error("Unexpected response status");
    }
  } catch (error) {
    console.error(
      "Salesforce API Error:",
      error.response?.data || error.message
    );
    return {
      success: false,
      msg: "Something went wrong while fetching Dealer Relationship Meet data.",
    };
  }
};


